// extracted by mini-css-extract-plugin
export default {"continue":"Kj-z"};